import { Icon } from "./Icon.tsx";

/** A document with a few lines of text — "view the (AEMET) report" (EditSubBasinDialog.tsx, once a fetch already happened, replacing the download button — see AemetProvenanceDialog.tsx). */
export function ReportIcon() {
  return (
    <Icon>
      <path d="M7 3h8l4 4v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M15 3v4h4" />
      <path d="M9 12h6M9 15.5h6M9 8.5h3" />
    </Icon>
  );
}
